import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';

const API = process.env.REACT_APP_API_URL || 'https://api.ctexpresskh.com/api';

export default function ExchangeRates() {
  const [rates, setRates] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { load(); }, []);

  const load = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch(API + '/exchange', { headers: { Authorization: 'Bearer ' + token } });
    const data = await res.json();
    if (data.success) setRates(data.data);
  };

  const save = async (rate) => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(API + '/exchange/' + rate.id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(rate)
      });
      const data = await res.json();
      if (data.success) { toast.success('Saved!'); setEditing(null); load(); }
      else toast.error(data.message);
    } catch { toast.error('Error saving'); }
    setLoading(false);
  };

  const updateRow = (rateId, rowIdx, field, value) => {
    setRates(prev => prev.map(r => {
      if (r.id !== rateId) return r;
      const newRows = [...r.rows];
      newRows[rowIdx] = { ...newRows[rowIdx], [field]: value };
      return { ...r, rows: newRows };
    }));
  };

  const addRow = (rateId) => {
    setRates(prev => prev.map(r => {
      if (r.id !== rateId) return r;
      return { ...r, rows: [...r.rows, { range: '', bank: '', alipay: '', alipay_wechat: '' }] };
    }));
  };

  const removeRow = (rateId, rowIdx) => {
    setRates(prev => prev.map(r => {
      if (r.id !== rateId) return r;
      const newRows = r.rows.filter((_, i) => i !== rowIdx);
      return { ...r, rows: newRows };
    }));
  };

  const updateField = (rateId, field, value) => {
    setRates(prev => prev.map(r => r.id === rateId ? { ...r, [field]: value } : r));
  };

  const s = {
    page: { padding: 24, background: '#f8fafc', minHeight: '100vh' },
    title: { fontSize: 22, fontWeight: 900, color: '#1e293b', marginBottom: 6 },
    sub: { color: '#64748b', fontSize: 14, marginBottom: 24 },
    card: { background: '#fff', borderRadius: 16, padding: 24, marginBottom: 24, boxShadow: '0 2px 8px #0001' },
    cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
    cardTitle: { fontSize: 16, fontWeight: 800, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 8 },
    editBtn: { background: '#f97316', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 18px', fontWeight: 700, cursor: 'pointer', fontSize: 13 },
    saveBtn: { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 18px', fontWeight: 700, cursor: 'pointer', fontSize: 13, marginRight: 8 },
    cancelBtn: { background: '#94a3b8', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 18px', fontWeight: 700, cursor: 'pointer', fontSize: 13 },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
    th: { background: '#1d4ed8', color: '#fff', padding: '10px 12px', textAlign: 'center', fontWeight: 700 },
    td: { padding: '8px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center', color: '#374151' },
    input: { border: '1px solid #e2e8f0', borderRadius: 6, padding: '5px 8px', width: '90%', fontSize: 13, textAlign: 'center' },
    inputWide: { border: '1px solid #e2e8f0', borderRadius: 6, padding: '5px 8px', width: '100%', fontSize: 13 },
    addRowBtn: { background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 8, padding: '6px 16px', fontWeight: 700, cursor: 'pointer', fontSize: 12, marginTop: 10 },
    removeBtn: { background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '3px 8px', cursor: 'pointer', fontSize: 12 },
    fieldRow: { display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' },
    fieldGroup: { display: 'flex', flexDirection: 'column', gap: 4, flex: 1, minWidth: 150 },
    label: { fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase' },
    noteInput: { border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', width: '100%', fontSize: 13, minHeight: 60, resize: 'vertical' },
  };

  return (
    <div style={s.page}>
      <div style={s.title}>💱 Exchange Rates</div>
      <div style={s.sub}>Manage money transfer rates shown in the mobile app</div>
      {rates.map(rate => (
        <div key={rate.id} style={s.card}>
          <div style={s.cardHeader}>
            <div style={s.cardTitle}>
              <span style={{ fontSize: 24 }}>{rate.flag}</span>
              {rate.country} ({rate.currency})
            </div>
            <div>
              {editing === rate.id ? (
                <>
                  <button style={s.saveBtn} onClick={() => save(rate)} disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
                  <button style={s.cancelBtn} onClick={() => { setEditing(null); load(); }}>Cancel</button>
                </>
              ) : (
                <button style={s.editBtn} onClick={() => setEditing(rate.id)}>Edit</button>
              )}
            </div>
          </div>
          {editing === rate.id && (
            <div style={s.fieldRow}>
              <div style={s.fieldGroup}>
                <label style={s.label}>Country</label>
                <input style={s.inputWide} value={rate.country} onChange={e => updateField(rate.id, 'country', e.target.value)} />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Currency</label>
                <input style={s.inputWide} value={rate.currency} onChange={e => updateField(rate.id, 'currency', e.target.value)} />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Flag (emoji)</label>
                <input style={s.inputWide} value={rate.flag} onChange={e => updateField(rate.id, 'flag', e.target.value)} />
              </div>
              <div style={s.fieldGroup}>
                <label style={s.label}>Rate Date</label>
                <input style={s.inputWide} type="date" value={rate.rate_date ? rate.rate_date.split('T')[0] : ''} onChange={e => updateField(rate.id, 'rate_date', e.target.value)} />
              </div>
            </div>
          )}
          <table style={s.table}>
            <thead>
              <tr>
                <th style={{ ...s.th, textAlign: 'left' }}>Range</th>
                <th style={s.th}>Bank (ធនាគារ)</th>
                <th style={s.th}>Alipay (រងចាំ)</th>
                <th style={s.th}>Alipay/WeChat (រហ័ស)</th>
                {editing === rate.id && <th style={s.th}>Action</th>}
              </tr>
            </thead>
            <tbody>
              {(rate.rows || []).map((row, i) => (
                <tr key={i}>
                  <td style={{ ...s.td, textAlign: 'left' }}>
                    {editing === rate.id ? <input style={s.inputWide} value={row.range} onChange={e => updateRow(rate.id, i, 'range', e.target.value)} /> : row.range}
                  </td>
                  <td style={s.td}>
                    {editing === rate.id ? <input style={s.input} value={row.bank} onChange={e => updateRow(rate.id, i, 'bank', e.target.value)} /> : <span style={{ color: '#1d4ed8', fontWeight: 700 }}>{row.bank}</span>}
                  </td>
                  <td style={s.td}>
                    {editing === rate.id ? <input style={s.input} value={row.alipay} onChange={e => updateRow(rate.id, i, 'alipay', e.target.value)} /> : <span style={{ color: '#1d4ed8', fontWeight: 700 }}>{row.alipay}</span>}
                  </td>
                  <td style={s.td}>
                    {editing === rate.id ? <input style={s.input} value={row.alipay_wechat} onChange={e => updateRow(rate.id, i, 'alipay_wechat', e.target.value)} /> : <span style={{ color: '#10b981', fontWeight: 700 }}>{row.alipay_wechat}</span>}
                  </td>
                  {editing === rate.id && <td style={s.td}><button style={s.removeBtn} onClick={() => removeRow(rate.id, i)}>X</button></td>}
                </tr>
              ))}
            </tbody>
          </table>
          {editing === rate.id && <button style={s.addRowBtn} onClick={() => addRow(rate.id)}>+ Add Row</button>}
          <div style={{ marginTop: 16 }}>
            <label style={s.label}>Note</label>
            {editing === rate.id
              ? <textarea style={s.noteInput} value={rate.note || ''} onChange={e => updateField(rate.id, 'note', e.target.value)} placeholder="Add a note..." />
              : rate.note ? <div style={{ fontSize: 13, color: '#374151', marginTop: 6, padding: '8px 12px', background: '#eff6ff', borderRadius: 8 }}>{rate.note}</div> : null}
          </div>
        </div>
      ))}
    </div>
  );
}
